export const getItem = (key, options = {}) => {
    const { raw } = options;
    let item;
    try {
        const value = window.localStorage.getItem(key);
        item = raw ? value : JSON.parse(value ?? '');
    }
    catch { }
    return item ?? null;
};
export const setItem = (key, value, options = {}) => {
    const { raw } = options;
    try {
        const resultValue = raw ? String(value) : JSON.stringify(value);
        window.localStorage.setItem(key, resultValue);
    }
    catch { }
};
export const removeItem = (key) => {
    try {
        window.localStorage.removeItem(key);
    }
    catch { }
};
